var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"track-list"},_vm._l((_vm.filteredTracks),function(track){return _c('TrackBadge',{key:track.id,staticClass:"track-list__item",attrs:{"track":track}},[_vm._v("\n    "+_vm._s(_vm.transl8(track.name))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }